import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import IconButton from 'patient-ping-remedy/packages/icon-button';

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
`;

export const CustomIconButton = styled(IconButton)`
  &:hover, &:focus-visible {
    background: ${colors.purple2};
  }
`;

export const AdditionalDetailsLabel = styled.div`
  font-weight: 600;
  color: ${colors.purple5};
  padding-top: ${sizes.xSmall};
  padding-bottom: ${sizes.xSmall};
  margin-top: -${sizes.xSmall};
  margin-bottom: -${sizes.xSmall}
`;
